import React from "react";
import { Link } from "react-router-dom";
import "./CalendarPage.css"; 
import SocialGroupLinkButton from "../components/SocialGroupLinkButton";
// import IconSocalFurs from './SocalDate.jpg'

export default function CalendarPage() {


  return (

       <div className = "calendar-main-container">
 
            
            <div className = "calendar-container-1">
                      <header className = "calendar-header">Welcome to Our Calendar Page!</header>
                        {/* <img className="homepage-main-icon" src={IconSocalFursDate} alt="Socalfurs.com" /> */}
                      <p className = "calendar-p"> 
                        The SocalFurs calendar is your centralized hub for furry events happening 
                        throughout Southern California. Powered by wolps it features up to date 
                        listings of meetups and local gatherings. Our goal is to make it 
                        easy for furries to discover, share, and stay informed about events.
                        Whether you're new or a longtime member of the community. If you are new,
                        we have some inofrmation that can help you get introduced to our furry
                        community:
                        <Link to="/events"> Newcomers: Attending A Furry Event</Link>
                        
                        <p></p>
                        <p className = "calendar-p" >You can also join our telegram groups below and get more information about events. Joining
                          <a href="https://telegram.org/"> Telegram</a> is highly reccomended!
                          <ul>
                            <li><a href = "https://t.me/+LPKHccQiNR03ZDQ7">SocalFurs Telegram</a></li>
                            <li><a href = "https://t.me/SoCalFursCalendar">Socal Furs Telegram Calendar Channel</a></li>
                            <p>You can view our event map below by clicking the map button too!</p>
                          </ul>

                                 </p>

                                
                                       
                        </p>    
            </div>
               
                   
            <div className = "calendar-container">
           
                  <SocialGroupLinkButton type="map" />
                          
                       

                <div className = "calendar-embed-container">
                    <iframe
                    title="Furry Events Calendar"
                    src="https://calendar.google.com/calendar/embed?src=1cdf9a4e9629d0b119d4daaa0e8ad0cc4d490b3cf95d458b0bf7247e323fb05e%40group.calendar.google.com&ctz=America/Los_Angeles"
                    className="calendar-src"
                     frameBorder="0"
                    ></iframe>
                </div>
            
            </div>
         
              <div className = "space"></div>
              <p className = "calendar-p"> 
                              <button><a href ="https://calendar.google.com/calendar/embed?src=1cdf9a4e9629d0b119d4daaa0e8ad0cc4d490b3cf95d458b0bf7247e323fb05e%40group.calendar.google.com&ctz=America/Los_Angeles">
                                Subscribe To Our Google Calendar!</a></button></p>

        </div>

         
  );
}
